import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_FLAG,
} from "./actionTypes";

const initialState = {
  resetSuccess: false,
  errorCount: 0,
  loading: false,
};

const resetPassword = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD:
      return {
        ...state,
        resetSuccess: false,
        loading: true,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetSuccess: true,
        loading: false,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetError: action.payload,
        errorCount: state.errorCount + 1,
        loading: false,
      };
    case RESET_PASSWORD_FLAG:
      return {
        ...state,
        resetError: null,
      };
    default:
      return state;
  }
};

export default resetPassword;
